import React, { FC, useEffect } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";

import Breadcrumbs from "../../shared/base-components/Breadcrumbs";

import { useDashboardMutation } from "./Dashboard.actions";
import SimpleBar from "simplebar-react";
import { useNavigate } from "react-router-dom";
import paths from "../../shared/route/paths";
import { appointmentFormatter } from "../Appointment/Appointment.constants";
import useCookie from "../../shared/hooks/useCookie";

const Dashboard: FC = () => {
  document.title = "Ana Sayfa | Ezrak";

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const navigate = useNavigate();
  const [, setCookieCustomerProfileId] = useCookie("customerProfileId");

  const { data, mutate, isLoading } = useDashboardMutation();

  useEffect(() => {
    mutate({});
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  const result =
    data?.maintenances_material_operation.reduce((acc: any, item) => {
      const key = `${item.device_part.id}-${item.operation_type}`;
      if (!acc[key]) {
        acc[key] = {
          ...item,
          count: 1,
        };
      } else {
        acc[key].count++;
      }
      return acc;
    }, {}) || [];

  const mergedArray = Object.values(result);

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          <Breadcrumbs title="Anasayfa" breadcrumbItem="Anasayfa" />

          {isLoading ? (
            <Spinner className="ms-3" color="primary" />
          ) : (
            <Row>
              <Col xl={4} md={6} key={"key"}>
                <Card className="card-h-100">
                  <CardBody>
                    <Row className="align-items-center">
                      <Col xs={6}>
                        <span className="text mb-3 lh-1 d-block text-truncate">
                          {"Bakım"}
                        </span>
                        <h4 className="mb-3">
                          <span className="counter-value">
                            {data?.maintenance_count}
                          </span>
                        </h4>
                      </Col>
                    </Row>
                    <div className="text-nowrap">
                      <span
                        className={
                          "badge badge-soft-" + "success" + " text-" + "success"
                        }
                      >
                        <span className="ms-1 text-muted font-size-13">
                          Bugün Yapılan Bakım Sayısı
                        </span>
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6} key={"key"}>
                <Card className="card-h-100">
                  <CardBody>
                    <Row className="align-items-center">
                      <Col xs={6}>
                        <span className="text mb-3 lh-1 d-block text-truncate">
                          {"Montaj"}
                        </span>
                        <h4 className="mb-3">
                          <span className="counter-value">
                            {data?.maintenance_setup_count}
                          </span>
                        </h4>
                      </Col>
                    </Row>
                    <div className="text-nowrap">
                      <span
                        className={
                          "badge badge-soft-" + "success" + " text-" + "success"
                        }
                      >
                        <span className="ms-1 text-muted font-size-13">
                          Bugün Yapılan Montaj Sayısı
                        </span>
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6} key={"key"}>
                <Card className="card-h-100">
                  <CardBody>
                    <Row className="align-items-center">
                      <Col xs={6}>
                        <span className="text mb-3 lh-1 d-block text-truncate">
                          {"Ödeme"}
                        </span>
                        <h4 className="mb-3">
                          <span className="counter-value">
                            {data?.paid_orders_count}
                          </span>
                        </h4>
                      </Col>
                    </Row>
                    <div className="text-nowrap">
                      <span
                        className={
                          "badge badge-soft-" + "success" + " text-" + "success"
                        }
                      >
                        <span className="ms-1 text-muted font-size-13">
                          Bugün Alınan Ödeme Sayısı
                        </span>
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Yapılacak İşler
                    </h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.todos.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.todos.map((todo) => {
                            return (
                              <li
                                onClick={() => {
                                  navigate(paths.TODO);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title bg-${
                                      todo?.person_who_complete !== null
                                        ? "success"
                                        : "warning"
                                    }-subtle text-warning rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-${
                                        todo?.person_who_complete !== null
                                          ? "check"
                                          : "circle"
                                      } font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {todo.name}
                                      </h5>
                                      <p className="text-truncate text-muted font-size-13">
                                        {todo.description}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <h6 className="mb-1">
                                        {formatDate(todo.date)}
                                      </h6>
                                      <div className="font-size-13">
                                        {todo?.person_who_complete !== null
                                          ? "Tamamlandı"
                                          : "Devam ediyor"}
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki yapılacak işler bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Randevular</h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.appointments.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.appointments.map((appointment) => {
                            return (
                              <li
                                onClick={() => {
                                  navigate(paths.APPOINTMENT);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title bg-${
                                      appointment?.is_completed
                                        ? "success"
                                        : "warning"
                                    }-subtle text-warning rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-${
                                        appointment?.is_completed
                                          ? "check"
                                          : "circle"
                                      } font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {appointment.customer?.fullname || ""}
                                      </h5>
                                      <p className="text-truncate text-muted font-size-13">
                                        {appointmentFormatter(
                                          appointment.appointment_type
                                        )}
                                      </p>

                                      <p className="text-truncate text-muted font-size-13">
                                        {appointment?.note}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <h6 className="mb-1">
                                        {formatDate(
                                          appointment?.appointment_datetime
                                        )}
                                      </h6>
                                      <div className="font-size-13">
                                        {appointment?.is_completed
                                          ? "Tamamlandı"
                                          : "Devam ediyor"}
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki randevu bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Bakımlar</h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.customer_devices.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.customer_devices.map((customer_device) => {
                            return (
                              <li
                                onClick={() => {
                                  setCookieCustomerProfileId(
                                    customer_device.customer?.id.toString(),
                                    9999
                                  );
                                  navigate(paths.CUSTOMER.CUSTORMER_PROFILE);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title  rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-user-circle font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {customer_device.customer?.fullname}
                                      </h5>

                                      <p className="text-truncate text-muted font-size-13">
                                        {customer_device?.description}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <div className="font-size-13">
                                        {
                                          customer_device?.customer
                                            ?.phone_number
                                        }
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki bakım bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Alınacak Ücretler
                    </h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.payments?.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.payments.map((paid_order) => {
                            return (
                              <li
                                onClick={() => {
                                  setCookieCustomerProfileId(
                                    paid_order.customer?.id.toString(),
                                    9999
                                  );
                                  navigate(paths.CUSTOMER.CUSTORMER_PROFILE);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title  rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-user-circle font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {paid_order?.customer.fullname}
                                      </h5>
                                      <p className="text-truncate text-muted font-size-13">
                                        {/* {paid_order?.is_partial
                                          ? "Taksitli"
                                          : "Peşin"} */}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <h6 className="mb-1">
                                        {paid_order?.retrieval}
                                      </h6>
                                      <div className="font-size-13">
                                        {/* {paid_order?.is_paid
                                          ? "Ödeme Alındı"
                                          : "Devam ediyor"} */}
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki alınacak ücretler bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Kullanılan Malzemeler
                    </h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {mergedArray.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {mergedArray.map((maintenances_material: any) => {
                            return (
                              <li className="activity-list activity-border">
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title bg-${
                                      maintenances_material.operation_type ===
                                      "assembly"
                                        ? "stats"
                                        : "wrench"
                                    }-subtle text rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-${
                                        maintenances_material.operation_type ===
                                        "assembly"
                                          ? "stats"
                                          : "wrench"
                                      } font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {maintenances_material.device_part.name}
                                      </h5>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <h6 className="mb-1">
                                        {maintenances_material.count} tane
                                      </h6>
                                      <div className="font-size-13">
                                        {maintenances_material.operation_type ===
                                        "replace"
                                          ? "Değiştirildi"
                                          : "Onarıldı"}
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>
                          Bu günki kullanılan malzemeler bulununmamaktadır.
                        </h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={4} md={6}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Yeni Eklenen Müşteriler
                    </h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.customers.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.customers.map((customer) => {
                            return (
                              <li
                                onClick={() => {
                                  setCookieCustomerProfileId(
                                    customer?.id.toString(),
                                    9999
                                  );
                                  navigate(paths.CUSTOMER.CUSTORMER_PROFILE);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title  rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-user-circle font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14">
                                        {customer?.fullname}
                                      </h5>

                                      <p className="text-truncate text-muted font-size-13">
                                        {customer?.description}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <div className="font-size-13">
                                        {customer?.phone_number}
                                      </div>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki eklenen müşteriler bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={12} md={12}>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Son İşlemler
                    </h4>
                  </CardHeader>

                  <CardBody className="px-0">
                    <SimpleBar
                      className="px-3"
                      style={{ maxHeight: "272px", minHeight: "272px" }}
                    >
                      {data?.logs.length ? (
                        <ul className="list-unstyled activity-wid mb-0">
                          {data?.logs.map((log) => {
                            return (
                              <li
                                onClick={() => {
                                  setCookieCustomerProfileId(
                                    log.customer?.id.toString(),
                                    999999
                                  );
                                  log.content_type === 1 || 2
                                    ? navigate(paths.CUSTOMER.CUSTORMER_PROFILE)
                                    : navigate(paths.EXPENSE);
                                }}
                                style={{ cursor: "pointer" }}
                                className="activity-list activity-border"
                              >
                                <div className="activity-icon avatar-md">
                                  <span
                                    className={`avatar-title bg-subtle text-warning rounded-circle`}
                                  >
                                    <i
                                      className={`bx bx-circle font-size-24`}
                                    ></i>
                                  </span>
                                </div>
                                <div className="timeline-list-item">
                                  <div className="d-flex">
                                    <div className="flex-grow-1 overflow-hidden me-4">
                                      <h5 className="font-size-14 mb-1">
                                        {log.customer?.fullname}
                                      </h5>
                                      <p className="text-truncate text-muted font-size-13">
                                        {log?.content}
                                      </p>
                                    </div>
                                    <div className="flex-shrink-0 text-end me-3">
                                      <h6 className="mb-1">
                                        {formatDate(log?.created_at)}
                                      </h6>
                                    </div>

                                    <div className="flex-shrink-0 text-end"></div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <h6>Bu günki işlemler bulununmamaktadır.</h6>
                      )}
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* <Col xl={4} md={6}>
            <Card>
              <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">Yapılacak İşler</h4>
                <div className="flex-shrink-0">
                  <select className="form-select form-select-sm mb-0 my-n1">
                    <option defaultValue="Today">Today</option>
                    <option value="Yesterday">Yesterday</option>
                    <option value="Week">Last Week</option>
                    <option value="Month">Last Month</option>
                  </select>
                </div>
              </CardHeader>

              <CardBody className="px-0">
                <SimpleBar className="px-3" style={{ maxHeight: "272px", minHeight:"272px" }}>
                  <ul className="list-unstyled activity-wid mb-0">
                    <li className="activity-list activity-border">
                      <div className="activity-icon avatar-md">
                        <span className="avatar-title bg-warning-subtle text-warning rounded-circle">
                          <i className="bx bx-check font-size-24"></i>
                        </span>
                      </div>
                      <div className="timeline-list-item">
                        <div className="d-flex">
                          <div className="flex-grow-1 overflow-hidden me-4">
                            <h5 className="font-size-14 mb-1">
                              24/05/2021, 18:24:56
                            </h5>
                            <p className="text-truncate text-muted font-size-13">
                              0xb77ad0099e21d4fca87fa4ca92dda1a40af9e05d205e53f38bf026196fa2e431
                            </p>
                          </div>
                          <div className="flex-shrink-0 text-end me-3">
                            <h6 className="mb-1">+0.5 BTC</h6>
                            <div className="font-size-13">$178.53</div>
                          </div>

                          <div className="flex-shrink-0 text-end">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="text-muted font-size-24"
                                tag="a"
                              >
                                <i className="mdi mdi-dots-vertical"></i>
                              </DropdownToggle>

                              <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem to="#">Action</DropdownItem>
                                <DropdownItem to="#">
                                  Another action
                                </DropdownItem>
                                <DropdownItem to="#">
                                  Something else here
                                </DropdownItem>
                                <div className="dropdown-divider"></div>
                                <DropdownItem to="#">
                                  Separated link
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="activity-list activity-border">
                      <div className="activity-icon avatar-md">
                        <span className="avatar-title  bg-primary-subtle text-primary rounded-circle">
                          <i className="mdi mdi-circle font-size-24"></i>
                        </span>
                      </div>
                      <div className="timeline-list-item">
                        <div className="d-flex">
                          <div className="flex-grow-1 overflow-hidden me-4">
                            <h5 className="font-size-14 mb-1">
                              24/05/2021, 18:24:56
                            </h5>
                            <p className="text-truncate text-muted font-size-13">
                              0xb77ad0099e21d4fca87fa4ca92dda1a40af9e05d205e53f38bf026196fa2e431
                            </p>
                          </div>
                          <div className="flex-shrink-0 text-end me-3">
                            <h6 className="mb-1">-20.5 ETH</h6>
                            <div className="font-size-13">$3541.45</div>
                          </div>

                          <div className="flex-shrink-0 text-end">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="text-muted font-size-24"
                                tag="a"
                              >
                                <i className="mdi mdi-dots-vertical"></i>
                              </DropdownToggle>

                              <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem to="#">Action</DropdownItem>
                                <DropdownItem to="#">
                                  Another action
                                </DropdownItem>
                                <DropdownItem to="#">
                                  Something else here
                                </DropdownItem>
                                <div className="dropdown-divider"></div>
                                <DropdownItem to="#">
                                  Separated link
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </SimpleBar>
              </CardBody>
            </Card>
          </Col> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
